import Axios  from "axios"

export const getCards = () => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARDS_GET_SUCCESS',
                payload: data.cards
            }) 
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardsOperators = () => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getalloperators/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){
            dispatch({
                type: 'CARDS_GET_SUCCESS',
                payload: data.cards
            }) 
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardsManagers = () => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getallmanagers/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){
            dispatch({
                type: 'CARDS_GET_SUCCESS',
                payload: data.cards
            }) 
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardDetail = (card) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/get/'+ card, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARD_GET_DETAIL_SUCCESS',
                payload: data.card
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardByOperator = (user) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getcardbyoperator/'+ user, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARD_GET_BY_OPERATOR_SUCCESS',
                payload: data.card
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardsByMonth = (month) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getcardsbymonth/', {
                params: {
                    month: month
                },
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARD_GET_BY_MONTH_SUCCESS',
                payload: data.cards
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardsByDate = (dayOne = false, dayTwo = false) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getcardsbydate/', {
                params: {
                    dayOne: dayOne,
                    dayTwo: dayTwo
                },
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARD_GET_BY_DATE_SUCCESS',
                payload: data.cards
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const getCardsByDateAndOperator = (dayOne, operator) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/getcardsbydateandoperator/', {
                params: {
                    dayOne: dayOne,
                    operator: operator,
                },
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CARD_GET_BY_DATE_BY_OPERATOR_SUCCESS',
                payload: data.cards
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const addCard = (user, datein, dateout, plot, crop, labor, extratime, extratimetype, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, image, products, product_extra, irrigation) => async (dispatch) => {
        dispatch({
        type: 'CARD_LOADING'
    })
    try {
        let imagen
        if(image !== null && image !== undefined && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            imagen = data
        }else{
            imagen = image
        }

        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/register', {
                user: user,
                in: datein,
                out: dateout,
                //campaign: campaign,
                plot: plot,
                crop: crop,
                labor: labor,
                extratime: extratime,
                extratimetype: extratimetype,
                machinery: machinery,
                litres_gasoil: litres_gasoil,
                litres_engine_oil: litres_engine_oil,
                litres_hydraulic_oil: litres_hydraulic_oil,
                litres_urea: litres_urea,
                // litres_antifreeze: litres_antifreeze,
                litres_grease: litres_grease,
                image: imagen,
                products: products,
                product_extra: product_extra,
                irrigation: irrigation
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newCard = {
                _id: data.id,
                user: user,
                in: datein,
                out: dateout,
                //campaign: campaign,
                plot: plot,
                crop: crop,
                labor: labor,
                extratime: extratime,
                extratimetype: extratimetype,
                machinery: machinery,
                litres_gasoil: litres_gasoil,
                litres_engine_oil: litres_engine_oil,
                litres_hydraulic_oil: litres_hydraulic_oil,
                litres_urea: litres_urea,
                // litres_antifreeze: litres_antifreeze,
                litres_grease: litres_grease,
                image: imagen,
                products: products,
                product_extra: product_extra,
                irrigation: irrigation
            }
            dispatch({
                type: 'CARD_ADD_SUCCESS',
                payload: newCard
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_FAIL'
        })
    }
}

export const editCard = (card) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        let imagen
        if(card.image !== null && card.image !== undefined && typeof card.image !== 'string'){
            let formData = new FormData()
            formData.append('image', card.image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            imagen = data
        }else{
            imagen = card.image
        }

        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/edit/' + card._id, {
                user: card.user,
                in: card.datein,
                out: card.dateout,
                //campaign: card.campaign,
                plot: card.plot,
                crop: card.crop,
                labor: card.labor,
                extratime: card.extratime,
                extratimetype: card.extratimetype,
                machinery: card.machinery,
                litres_gasoil: card.litres_gasoil,
                litres_engine_oil: card.litres_engine_oil,
                litres_hydraulic_oil: card.litres_hydraulic_oil,
                litres_urea: card.litres_urea,
                // litres_antifreeze: card.litres_antifreeze,
                litres_grease: card.litres_grease,
                image: imagen,
                products: card.productList,
                product_extra: card.product_extra,
                irrigation: card.irrigation
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CARD_EDIT_SUCCESS',
            payload: {
                user: card.user,
                in: card.datein,
                out: card.dateout,
                //campaign: card.campaign,
                plot: card.plot,
                crop: card.crop,
                labor: card.labor,
                extratime: card.extratime,
                extratimetype: card.extratimetype,
                machinery: card.machinery,
                litres_gasoil: card.litres_gasoil,
                litres_engine_oil: card.litres_engine_oil,
                litres_hydraulic_oil: card.litres_hydraulic_oil,
                litres_urea: card.litres_urea,
                // litres_antifreeze: card.litres_antifreeze,
                litres_grease: card.litres_grease,
                image: imagen,
                products: card.productList,
                product_extra: card.product_extra,
                irrigation: card.irrigation,
                _id: card._id
            }
        })
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const removeCard = (idCard) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/remove/' + idCard, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CARD_DELETE_SUCCESS',
                payload: {
                    idCard: idCard,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'CARD_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}

export const approveCards = (card, miliseconds, hourstype) => async (dispatch) => {
    dispatch({
        type: 'CARD_LOADING'
    })
    try {
        const {data} = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/card/approvecard/'+ card, {miliseconds: miliseconds, hourstype: hourstype}, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CARD_EDIT_SUCCESS',
            payload: data.card
        })
    } catch (error) {
        dispatch({
            type: 'CARD_ERROR'
        })
    }
}